import { useState } from 'react';
import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official';
import {currencyFormat, updateChartTheme} from "../../../utils/helpsers";

require("highcharts/modules/accessibility")(Highcharts);

function ErrorBarsChart({ data }) {
  const [showRawDataTable, setShowRawDataTable] = useState(false);

  const options = {
    chart: {
      zoomType: 'xy',
      height: 530,
      backgroundColor: '#fff',
    },
    title: {
      text: 'Salary Indexes'
    },
    xAxis: {
      categories: data?.categories,
      min: 0,
      max: 37,
      tickInterval: 1,
    },
    tooltip: {
      formatter: function () {
        if (this.point.series.type === 'errorbar') {
          const min = currencyFormat(this.point.low);
          const max = currencyFormat(this.point.high);
          return `Min: <strong>${min}</strong> - Max: <strong>${max}</strong>`;
        }
        return `${this.series.name}: <strong>${currencyFormat(this.point.y)}</strong>` // Keep the default format for all non errorbar series.
      }
    },
    legend: {
      maxHeight: 100
    },
    exporting: {
      tableCaption: false,
      buttons: {
        contextButton: {
          menuItems: [
            "viewFullscreen",
            {
              text: "Toggle Light/Dark mode",
              onclick: function () {
                updateChartTheme(this);
                this.series[0].update({
                  color: this.userOptions.chart.backgroundColor === '#333' ? '#fff' : '#333',
                })
              }
            },
            {
              separator: true,
            },
            {
              text: "Download PDF document",
              onclick: function () {
                this.exportChart({
                  type: "application/pdf",
                });
              },
            },
            {
              text: "Download CSV",
              onclick: function () {
                this.downloadCSV();
              },
            },
            {
              text: "Download XLS",
              onclick: function () {
                this.downloadXLS();
              },
            },
            {
              separator: true,
            },
            {
              text: showRawDataTable ? "Hide Raw Data Table" : "Show Raw Data Table",
              onclick: function () {

                if (showRawDataTable) {
                  setShowRawDataTable(!showRawDataTable);
                  this.hideData();

                } else {
                  setShowRawDataTable(!showRawDataTable);
                  this.viewData()
                }
              }
            }
          ],
        },
      },
    },
    series: data?.series,
  }

  return (
    <HighchartsReact
      highcharts={Highcharts}
      options={options}
    />
  )
}

export default ErrorBarsChart;
